<template>
  <material-dialog
    :cancelText="cancelText"
    :confirmText="confirmText"
    :title="title"
    :text="text"
    :show="confirmDialog"
    :width="450"
    @close="$store.dispatch('hideConfirmDialog')"
    @confirm="$store.dispatch('confirm')"
  />
</template>

<script>
import { mapState } from 'vuex';

import MaterialDialog from '@/components/material/Dialog';

export default {
  components: { MaterialDialog },
  data() {
    return {
      confirmDialog: false
    };
  },
  computed: {
    ...mapState({
      show: state => state.modalClose.show,
      title: state => state.modalClose.title,
      text: state => state.modalClose.text,
      confirmText: state => state.modalClose.confirmText,
      cancelText: state => state.modalClose.cancelText
    })
  },
  watch: {
    show(val) {
      this.confirmDialog = val;
    }
  }
};
</script>
